module.exports = __webpack_public_path__ + "img/marketFriend.66bd8465.svg";